"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.event = void 0;
var data_layer_1 = require("@nuuday/data-layer");
var event = function (data) {
    try {
        (0, data_layer_1.event)(data);
    }
    catch (e) {
        // do nothing - as we can't do anything about tracking errors
    }
};
exports.event = event;
//# sourceMappingURL=tracking.js.map